"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleIntegration = void 0;
var console_1 = require("./console");
Object.defineProperty(exports, "consoleIntegration", { enumerable: true, get: function () { return console_1.consoleIntegration; } });
//# sourceMappingURL=index.js.map